import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MtnaPopoverModule, MtnaSelectSearchModule } from '@mtna/core-angular';

import { RdsChipsModule } from '../chips/index';
import { RdsPopoverAriaLabelPipeModule } from '../core/pipes';
import { RdsCoreResourceExistsPipeModule } from '../core/pipes/core-resource-exists.pipe';
import { RdsVariablesToChipsPipe } from './variable-chips.pipe';
import { RdsVariableSelectComponent } from './variable-select.component';

const COMPONENTS = [RdsVariableSelectComponent];
const PIPES = [RdsVariablesToChipsPipe];

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatFormFieldModule,
    MatIconModule,
    MatSelectModule,
    MtnaPopoverModule,
    MtnaSelectSearchModule,
    RdsChipsModule,
    RdsCoreResourceExistsPipeModule,
    RdsPopoverAriaLabelPipeModule,
    ScrollingModule,
  ],
  exports: [COMPONENTS, PIPES],
  declarations: [COMPONENTS, PIPES],
})
export class RdsVariableSelectModule {}

export * from './variable-select.component';
export * from './variable-chips.pipe';
